<template>
  <button
    v-bind="$attrs"
    :class="[
      $style.button,
      ghostButton ? $style.ghost : '',
      disabled ? $style.disabled : '',

    ]"
    :disabled="disabled"
    @click="onClickHandler"
  >
    <slot />
  </button>
</template>
<script setup lang="ts">

const emits = defineEmits(['click'])
defineProps({
  ghostButton: {
    type: Boolean
  },
  disabled: {
    type: Boolean
  }
})

const onClickHandler = (event) => {
  emits('click', event)
}
</script>

<style module>
.button {
  font-size: clamp(15px, 2vw, 18px);
  line-height: clamp(19px, 2vw, 21px);
  font-weight: 500;
  border: 2px solid;
  border-radius: 4px;
  padding: 16px;
  text-align: center;
  width: 100%;
  cursor: pointer;
  color: var(--color-white);
  background: var(--color-pacificblue);
  border-color: var(--color-pacificblue);

  &:focus {
    outline-width: 4px;
    outline-offset: 4px;
    outline-color: var(--color-pacificblue);
  }

  &+& {
    margin-top: var(--space-xs);
  }

  &.ghost {
    color: var(--color-blackcoral);
    background: var(--color-white);
    border-color: var(--color-blackcoral);

    &:focus {
      outline-color: var(--color-blackcoral);
    }
  }
}

.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>
